import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  goodPin?: boolean;
  wrongPin?: boolean;
  focused?: boolean;
  pin?: string;
}

const PinInput = styled.input`
  /* Base Styling */
  font-size: 4rem;
  letter-spacing: 15px;
  padding: 5px 8px;
  border-radius: 3px;
  width: 220px;
  height: 60px;
  box-sizing: border-box;

  border: 1px solid ${theme.color.gray.medium};
  border-radius: ${theme.global.radius};
  transition: ${theme.global.transition};

  ${({ goodPin }: IProps) =>
    goodPin
      ? `
    color: ${theme.color.tertiary};
    `
      : ``};

  ${({ wrongPin }: IProps) =>
    wrongPin
      ? `
        color: ${theme.color.red};
        `
      : ``};

  ${({ focused }: IProps) =>
    focused
      ? `
    border: 2px inset ${theme.color.primary};
    `
      : ``};
`;

export default PinInput;



// WEBPACK FOOTER //
// ./src/components/common/PinInput/PinInputControl.tsx